var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Digital Marketing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.646 3C19.1533 3 18.7034 3.28035 18.4823 3.72157L17.7895 5.11111L11.0584 8.00358C10.671 8.17036 10.4211 8.55033 10.4211 8.97255V16.0254C10.4211 16.4476 10.671 16.8307 11.0584 16.9964L17.7895 19.8889L18.4823 21.2784C18.7034 21.7197 19.1533 22 19.646 22C20.3649 22 20.9474 21.4159 20.9474 20.695V14.3245C21.2669 14.1396 21.5323 13.8737 21.717 13.5534C21.9018 13.2332 21.9993 12.8699 22 12.5C21.9997 12.1297 21.9023 11.766 21.7175 11.4454C21.5328 11.1248 21.2672 10.8585 20.9474 10.6734V4.30501C20.9474 3.58407 20.3649 3 19.646 3ZM4.10526 8.27778C2.94737 8.27778 2 9.22778 2 10.3889V14.6111C2 15.7722 2.94737 16.7222 4.10526 16.7222H6.21053V20.9444C6.21053 21.5271 6.68211 22 7.26316 22C7.84421 22 8.31579 21.5271 8.31579 20.9444V14.6111V9.33333C8.31579 8.75067 7.84421 8.27778 7.26316 8.27778H4.10526Z",
    fill: "black",
    fillOpacity: 0.54
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketing);
export default __webpack_public_path__ + "static/media/Digital Marketing.545309efed72eafcf51a269edd30252d.svg";
export { ForwardRef as ReactComponent };